import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://mis.empowerplus.in",
    headers: {
        "Content-Type": "application/json",
    },
});

// 🔐 Attach token automatically
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ❌ Handle 401 / 403 globally
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error(
            "API ERROR:",
            error.response?.status,
            error.config?.url
        );
        return Promise.reject(error);
    }
);

export default axiosInstance;
